<template>
  <v-card flat class="my-0">
    <v-card-text>
      <draggable :list="field.listElements" class="list-group">
        <v-text-field
          v-for="(element, index) in field.listElements"
          :key="index"
          v-model="element.value"
          prepend-icon="mdi-drag-horizontal-variant"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="red"
                  @click.prevent="removeElement(index)"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:append-outer v-if="showAdd(index)">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="primary"
                  @click.prevent="add"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add") }}</span>
            </v-tooltip>
          </template>
        </v-text-field>
      </draggable>
      <v-layout row justify-center v-if="field.listElements.length == 0">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small color="primary" @click.prevent="add" v-on="on">
              {{ $t("Add") }}
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Add") }}</span>
        </v-tooltip>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import ListElement from "@/ecm/models/contentType/ContentTypeFieldListElement";

export default {
  components: {
    draggable,
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    showAdd(index) {
      return this.field.listElements.length == index + 1;
    },
    removeElement(index) {
      this.field.listElements.splice(index, 1);
    },
    add: function () {
      this.field.listElements.push(new ListElement());
    },
  },
};
</script>

<style>
</style>